import React from 'react';
import css from '../../../styles/modules/PaymentSummary/infocard.module.css';
import StatusTag from './InfoCardComponents.js/StatusTag';

import FromToCircle from './InfoCardComponents.js/FromToCircle';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import getUSStateAbbreviation from '../lib/getUSStateAbbreviation';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { BsPaperclip } from 'react-icons/bs';

export default function InfoCard({
  fee,
  attachments,
  sourceBankAccount,
  destBankAccount,
  transferId,
  tenantId,
  method,
  propertyCity,
  propertyState,
  propertyZipcode,
  propertyAddress1,
  propertyAddress2,
  purpose,
  amount,
  disbursement,
  status,
  type,
  client,
  tenant,
  tenantLogo,
  updatedAt,
  createdAt,
  transferType,
}) {
  const history = useHistory();
  const totalAmount = (Number(fee) + Number(amount)).toFixed(2);

  function returnButton() {
    if (
      disbursement === true &&
      (status.toLowerCase() === 'sent' || status.toLowerCase() === 'viewed')
    ) {
      return {
        btn: (
          <button
            onClick={() =>
              history.push(
                `/create-account/step-select-account?go_to_transfer=${transferId}?disbursement=select-bank`,
              )
            }
            className={css.btnGreen}
          >
            Accept Funds
          </button>
        ),
      };
    }

    if (
      status?.toLowerCase() === 'awaiting wire' ||
      (method?.toLowerCase() === 'wire' &&
        status?.toLowerCase() !== 'completed')
    ) {
      return {
        btn: (
          <button
            onClick={() =>
              history.push(
                `/create-account/wiring-instructions?transfer_id=${transferId}&tenant_id=${tenantId}`,
              )
            }
            className={css.btnGreen}
          >
            Wire Instructions
          </button>
        ),
      };
    } else {
      return {
        btn: (
          <button
            onClick={() => history.push(`/payment-details/${transferId}`)}
            className={css.btnWhite}
          >
            View Details
          </button>
        ),
      };
    }
  }

  function returnText3() {
    if (
      status?.toLowerCase() === 'awaiting wire' ||
      method?.toLowerCase() === 'wire'
    ) {
      return 'via Wire Transfer';
      //if transfer from client to tenant -> sourceBankAccount === clients account
    } else if (
      method?.toLowerCase() === 'ach' &&
      type?.toLowerCase() !== 'client disbursement'
    ) {
      return `from ${sourceBankAccount?.bankName || ''} x${sourceBankAccount?.accountLastFourDigits || ''}`;
      //if transfer from tenant to client -> destBankAccount === clients account
    } else if (
      method?.toLowerCase() === 'ach' &&
      type?.toLowerCase() === 'client disbursement'
    ) {
      return `into ${destBankAccount?.bankName || ''} x${destBankAccount?.accountLastFourDigits || ''}`;
    }
  }

  function returnText1(status, disbursement) {
    // If status is not provided, return an empty string
    if (!status) {
      return ' ';
    }

    if (!amount) {
      return ' ';
    }

    // Convert status to lowercase for comparison
    const statusLower = status.toLowerCase();

    switch (statusLower) {
      case 'completed':
      case 'pending':
        return disbursement ? 'You accepted' : 'You sent';
      case 'awaiting wire':
        return 'You plan to send';
      case 'awaiting acceptance':
        return 'You were sent';
      default:
        return disbursement ? 'You were sent' : 'You sent';
    }
  }

  function formatAddress(city, state, zipcode) {
    let addressParts = [];

    if (city) {
      addressParts.push(city);
    }

    if (state) {
      let abbreviatedState = getUSStateAbbreviation(state);
      if (abbreviatedState) {
        addressParts.push(abbreviatedState);
      }
    }

    if (zipcode) {
      addressParts.push(zipcode);
    }

    return addressParts?.length > 0 ? addressParts?.join(', ') : '';
  }

  function downloadAll(attachments) {
    attachments.forEach((attachment) => {
      const link = document.createElement('a');
      link.href = attachment.fileURL;
      link.target = '_blank';
      link.download = attachment.name || ''; // this will suggest the filename for saving
      document.body.appendChild(link); // Needs to be added to the DOM to work in some browsers
      link.click();
      document.body.removeChild(link); // Remove the link after triggering the download
    });
  }

  return (
    <div className={css.cardWrapper}>
      <StatusTag status={status} />
      <FromToCircle
        tenantLogo={tenantLogo}
        type={type}
        client={client}
        tenant={tenant}
      />
      {/* Safely check for updatedAt */}
      <p className={css.date}>
        {updatedAt ? moment(updatedAt).format('MMMM, D YYYY @ HH:mm a') : ' '}
      </p>
      <p className={css.text1}>{returnText1(status, disbursement)}</p>
      <p className={css.amount}>
        {amount ? (
          <NumericFormat
            displayType="text"
            prefix="$"
            value={Number(totalAmount)}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          />
        ) : (
          ' '
        )}
      </p>
      <p className={css.text3}>{returnText3()}</p>
      <p className={css.text2}>{purpose ? `For ${purpose}` : ' '}</p>

      <div className={css.addressContainer}>
        <p className={css.addressHeadline}>
          {formatAddress(propertyCity, propertyState, propertyZipcode)?.length >
          0
            ? 'Property Address:'
            : ' '}
        </p>
        {/* Safely check for property address details */}
        <p className={css.address}>{propertyAddress1 ?? ' '}</p>
        {propertyAddress2 && <p className={css.address}>{propertyAddress2}</p>}
        <p className={css.address}>
          {formatAddress(propertyCity, propertyState, propertyZipcode)}
        </p>
      </div>
      <div className={css.returnButtonContainer}>
        {returnButton().btn}
        {attachments?.length ? (
          <button className={css.paperClipBtn}>
            <BsPaperclip
              onClick={() => downloadAll(attachments)}
              className={css.paperClip}
            />
          </button>
        ) : null}
      </div>
    </div>
  );
}
